import { useState, useRef, useEffect } from "react";
import {
  Typography,
  Row,
  Col,
  Upload,
  Modal,
  Progress,
  Alert,
  message,
  Form,
  Input,
  Select,
} from "antd";
import { InboxOutlined } from "@ant-design/icons";
import axios from "axios";
import API_KEY from "../../../api";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  return isJpgOrPng;
}

const { Option } = Select;

export default function UploadImages({ form, images, products_id }) {
  const [fileList, setFileList] = useState([]);
  const [imagesList, setImagesList] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);
  const colors = [];
  const color_options = [
    { value: "White" },
    { value: "Off White" },
    { value: "Black" },
    { value: "Grey" },
    { value: "Beige" },
    { value: "Brown" },
    { value: "Green" },
    { value: "Olive" },
    { value: "Teal" },
    { value: "Yellow" },
    { value: "Mustard" },
    { value: "Rust" },
    { value: "Red" },
    { value: "Magenta" },
    { value: "Pink" },
    { value: "Orange" },
    { value: "Sky Blue" },
    { value: "Dark Blue" },
    { value: "Blue" },
    { value: "Turquoise" },
    { value: "Purple" },
    { value: "Violet" },
  ];

  const [colours, setColours] = useState(null);
  const photosList = useRef([]);

  // set fileList in the form field
  useEffect(() => {
    form.setFieldsValue({
      product_images: imagesList.map((file) => {
        return file?.uid || file;

        // {
        //   directus_files_id: file?.image_id,
        //   products_id: parseInt(products_id),
        //   id:file?.uid
        // };
      }),
    });
  }, [form, imagesList, products_id]);

  const handleCancel = () => {
    setPreviewVisible(false);
  }; // api call for colours
  useEffect(() => {
    API_KEY.URL.get(API_KEY.path.colours)
      .then((res) => {
        setColours(res?.data?.data);
      })
      .catch((error) => console.log(error));
  }, []);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
    setPreviewVisible(true);
    setPreviewImage(file.url || file.preview);
  };
  // add existing images to fileList
  useEffect(() => {
    if (images) {
      images.length > 0 &&
        setImagesList(
          images.map((image) => {
            return {
              image_id: image?.directus_files_id,
              uid: image?.id,
              status: "done",
              url: image.directus_files_id
                ? `${process.env.REACT_APP_DIRECTUS}assets/${image?.directus_files_id}?fit=cover&width=600&height=600&quality=80`
                : "http://placehold.jp/24/0a8f8d/ffffff/283x214.png?text=Product Image",
            };
          })
        );
      images.length > 0 &&
        setFileList(
          images.map((image) => {
            return {
              image_id: image?.directus_files_id,
              uid: image?.id,
              status: "done",
              url: image.directus_files_id
                ? `${process.env.REACT_APP_DIRECTUS}assets/${image?.directus_files_id}?fit=cover&width=600&height=600&quality=80`
                : "http://placehold.jp/24/0a8f8d/ffffff/283x214.png?text=Product Image",
            };
          })
        );
    }
  }, [images]);

  console.log(colours);
  const handleChangeUpload = (info) => {
    setFileList(info.fileList);

    if (info.file.status === "uploading") {
      // setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(
        info.file.originFileObj
        // (imageUrl) => setImageUrl(imageUrl),
        // setLoading(false)
      );
    }
  };

  const uploadImage = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;

    const fmData = new FormData();
    const config = {
      headers: { "content-type": "multipart/form-data" },
      onUploadProgress: (event) => {
        const percent = Math.floor((event.loaded / event.total) * 100);
        setProgress(percent);
        if (percent === 100) {
          setTimeout(() => setProgress(0), 1000);
        }
        onProgress({ percent: (event.loaded / event.total) * 100 });
      },
    };
    fmData.append("image", file);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_DIRECTUS}files`,
        fmData,
        config
      );
      file.thumbUrl = `${process.env.REACT_APP_DIRECTUS}assets/${res.data?.data?.id}?fit=cover&width=600&height=600&quality=80`;
      onSuccess("Ok");
      console.log("server res: ", res);
      photosList.current.push({ directus_files_id: res.data?.data?.id });

      setImagesList((state) => [
        ...state,
        { directus_files_id: res.data?.data?.id },
      ]);
      // setFileList((state) => [
      //   ...state,
      //   { directus_files_id: res.data?.data?.id },
      // ]);
    } catch (err) {
      setError("Something went wrong");
      onError({ err });
    }
  };
  const uploadButton = (
    <div>
      <InboxOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );
  const [categories, setCategories] = useState(null);
  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  useEffect(() => {
    API_KEY.URL.get(API_KEY.path.manufacturer_secondary_category)
      .then((res) => {
        console.log(res.data);
        setCategories(res?.data?.data);
      })
      .catch((error) => console.log(error));
  }, []);

  /// tags
  const onRemove = (file) => {
    //  setFileList(state=>state.filter((item) => item.uid !== file.uid));
    setImagesList((state) => state.filter((item) => item.uid !== file.uid));
    return true;
  };
  return (
    <>
      {error && <Alert type="error" message={error} banner />}
      <Row>
        <Typography.Title level={4} style={{ fontFamily: "Gilroy" }}>
          Upload Pictures
        </Typography.Title>
      </Row>

      <Row style={{ marginTop: "2rem" }}>
        <Col span={24}>
          <Form.Item
            name="upload"
            rules={[
              {
                required: false,
                message: "Upload atleast one image",
              },
            ]}
          >
            <Upload
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              customRequest={uploadImage}
              beforeUpload={beforeUpload}
              onChange={handleChangeUpload}
              onRemove={onRemove}
            >
              {fileList.length >= 8 ? null : uploadButton}
            </Upload>
          </Form.Item>
          {progress > 0 ? <Progress percent={progress} /> : null}
          <Modal
            visible={previewVisible}
            title={previewTitle}
            footer={null}
            onCancel={handleCancel}
          >
            <img alt="example" style={{ width: "100%" }} src={previewImage} />
          </Modal>
        </Col>
      </Row>
      {/* <Row>
        {images &&
          images.map((image, index) => (
            <Col    key={index} xs={24} sm={24} md={12} lg={8} xl={8}>
              <img
             
                alt="example"
                style={{ width: "80%" }}
                src={
                  image
                    ? `${process.env.REACT_APP_DIRECTUS}assets/${image?.directus_files_id}?fit=cover&width=200&height=200&quality=100`
                    : "http://placehold.jp/24/0a8f8d/ffffff/283x214.png?text=Product Image"
                }
              />
            </Col>
          ))}
      </Row> */}

      <Row style={{ marginTop: "2rem" }}>
        <Col span={24}>
          <Row>
            <Typography.Title level={5} style={{ fontFamily: "Gilroy" }}>
              Select the colors of this product
            </Typography.Title>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item name="color_tag">
                <Select
                  mode="tags"
                  style={{ width: "100%" }}
                  placeholder="Colors"
                  options={color_options}
                >
                  {colors}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={10}>
        <Col span={12}>
          <Form.Item
            hasFeedback
            label="Category"
            name="secondary_category"
            rules={[{ required: true, message: "Please select category" }]}
            {...formItemLayout}
          >
            <Select
              showSearch
              placeholder="Select a category"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {/* TODO: fill Categories */}

              {categories &&
                categories.map(
                  (item, index) =>
                    item?.secondary_category_id?.id && (
                      <Option
                        key={index}
                        value={item?.secondary_category_id?.id}
                      >
                        {item?.secondary_category_id.name}
                      </Option>
                    )
                )}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Product ID" name="product_id" {...formItemLayout}>
            <Input placeholder="Enter Product ID" />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item label="Name" name="name" {...formItemLayout}>
            <Input placeholder="Enter the name of  your product" />
          </Form.Item>
        </Col>
      </Row>
      <div hidden>
        <Form.Item label="photos" name="product_images">
          <Input />
        </Form.Item>
      </div>
    </>
  );
}

//product_images: [5, {directus_files_id: "d28efeb0-4d66-4f2a-bc17-99b7bdc36007"}]
